var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};

// src/league-fetch.ts
import { getConfig } from "@leagueplatform/config";
import {
  captureError,
  combineErrorContexts
} from "@leagueplatform/observability";

// src/utils.ts
import { Auth } from "@leagueplatform/auth";
import { getCurrentLocale } from "@leagueplatform/locales";
import { hasLegacyAuthValues } from "@leagueplatform/auth-legacy";
var getAcceptLanguageHeader = () => {
  const userLocale = getCurrentLocale();
  return {
    headers: new Headers({
      "accept-language": userLocale
    })
  };
};
var noAuthOptions = {};
var getLeagueFetchOptions = (allowUnauthenticated = false) => __async(void 0, null, function* () {
  if (Auth.initialized) {
    try {
      const token = yield Auth.getToken();
      return {
        headers: {
          Authorization: `Bearer ${token}`
        }
      };
    } catch (e) {
      if (allowUnauthenticated) {
        return noAuthOptions;
      }
      throw e;
    }
  }
  if (hasLegacyAuthValues()) {
    return { credentials: "include" };
  }
  if (allowUnauthenticated) {
    return noAuthOptions;
  }
  throw new Error(
    "unable to retrieve auth state; make sure you call StandaloneAuth.initialize"
  );
});
var combineHeaders = (...fetchOptions) => {
  const result = {};
  fetchOptions.forEach((options) => {
    if (!options.headers)
      return;
    const headers = new Headers(options.headers);
    Array.from(headers.entries()).forEach(([key, value]) => {
      result[key] = value;
    });
  });
  return new Headers(result);
};

// src/league-fetch.ts
var leagueFetch = (_0, ..._1) => __async(void 0, [_0, ..._1], function* (path, options = {}) {
  var _b, _c, _d, _e;
  const {
    core: {
      api: { url: apiUrl },
      contentUrl,
      clientId,
      appVersion
    }
  } = getConfig().config;
  const _a = options, {
    allowUnauthenticated,
    api = "rest",
    errorContext: optionalErrorContext = {}
  } = _a, fetchOptions = __objRest(_a, [
    "allowUnauthenticated",
    "api",
    "errorContext"
  ]);
  const leagueFetchOptions = yield getLeagueFetchOptions(allowUnauthenticated);
  const getCurrentLocale2 = getAcceptLanguageHeader();
  const clientIdOptions = {
    headers: new Headers(__spreadValues(__spreadValues({}, api === "rest" ? { "X-League-Client-Id": clientId } : {}), appVersion && { "X-League-Client-Version": appVersion }))
  };
  const url = `${api === "rest" ? apiUrl : contentUrl}${path.replace(
    /^\/?/,
    "/"
  )}`;
  const promise = fetch(url, __spreadProps(__spreadValues(__spreadValues({}, fetchOptions), leagueFetchOptions), {
    headers: combineHeaders(
      fetchOptions,
      leagueFetchOptions,
      getCurrentLocale2,
      clientIdOptions
    )
  }));
  const response = yield promise;
  if (!response.ok) {
    const body = yield response.clone().json();
    const errorDetail = (_d = (_c = (_b = body.errors) == null ? void 0 : _b[0]) == null ? void 0 : _c.detail) != null ? _d : "An error has occurred";
    const fetchErrorContext = combineErrorContexts([
      {
        errorName: "Network Fetch Error",
        tags: { requestUrl: response.url },
        context: {
          Errors: __spreadValues({}, body.errors),
          Response: {
            ok: response.ok,
            redirected: response.redirected,
            status: response.status,
            type: response.type,
            url: response.url,
            method: (_e = fetchOptions.method) != null ? _e : "GET"
          }
        }
      },
      optionalErrorContext
    ]);
    captureError(new Error(errorDetail), fetchErrorContext);
  }
  return promise;
});
export {
  leagueFetch
};


  if (typeof window !== 'undefined' && !(typeof process !== 'undefined' && process.env?.NODE_ENV === 'test')) {
    window.leagueSDKsPresent = window.leagueSDKsPresent || [];
    window.leagueSDKsPresent['@leagueplatform/league-fetch'] = window.leagueSDKsPresent['@leagueplatform/league-fetch'] || [];
    window.leagueSDKsPresent['@leagueplatform/league-fetch'].push('2.27.1');

    const numInstances = window.leagueSDKsPresent['@leagueplatform/league-fetch'].length

    if (numInstances > 1) {
      console.error('Multiple copies (' + numInstances + ') of the @leagueplatform/league-fetch module are loaded! This can cause issues. Ensure that your project bundle only contains one copy/version of each League SDK package.');
    }
  }
  
//# sourceMappingURL=index.js.map